import 'modules/carousel-swiper/carousel-swiper-custom'
import 'modules/carousel-swiper/carousel-swiper-register'
import lazysizes from 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import NoticeGlobal from 'snippets/notice-global/notice-global'
import register from 'preact-custom-element'
import SearchBar from 'modules/search-bar/search-bar-searchspring'
import 'libs/accessibility'
import 'styles/theme.css'
import 'snippets/accordion-list/accordion-list'
import 'snippets/embla-carousel/embla-carousel'
import 'snippets/modal-dialog/modal-dialog'
import 'snippets/notice-main/notice-main'
import 'snippets/read-more/read-more'
import 'snippets/validate-form/validate-form'
import 'snippets/video-player/video-player'
import 'snippets/slideout/slideout'
import 'snippets/form/custom-input-password/custom-input-password'
import 'snippets/regionalisation-selector/regionalisation-selector'
import 'snippets/quiz-bar/quiz-bar'
import 'snippets/button-scroll/button-scroll'
import 'snippets/yett-blacklist/flying-scripts'
import 'modules/loyalty/loyalty-message-cart/loyalty-message-cart'
import 'modules/tab-half-and-half/tab-half-and-half'

register(NoticeGlobal, 'notice-global')
register(SearchBar, 'search-bar')

lazysizes.init()
